module.exports = __webpack_public_path__ + "img/bg5.b7cebc39.jpg";